import { IHttpApi } from '@cian/http-api/shared';

import { ILogger } from '@cian/logger';
import { IVillagesOffersSummarySchema } from '../repositories/countryside-search/entities/offers_summary/VillagesOffersSummarySchema';
import { ResponseError } from '../errors/ResponseError';
import {
  IGetVillageListSummaryRequest,
  TGetVillageListSummaryResponse,
  fetchGetVillageListSummary,
} from '../../node/repositories/countryside-search/v1/get-village-list-summary';

export async function getVillageListSummary(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: IGetVillageListSummaryRequest,
): Promise<IVillagesOffersSummarySchema | null> {
  try {
    const { response, statusCode }: TGetVillageListSummaryResponse = await fetchGetVillageListSummary({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getVillageListSummary',
        message: response.message,
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response.offersAggs;
  } catch (error) {
    logger.error(error, { message: 'Error in getVillageListSummary' });

    return null;
  }
}
